import { useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import api, { formatErr } from "@/lib/api";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const token = params.get("token");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password updated. Please sign in.");
      navigate("/login");
    } catch (err) {
      toast.error(formatErr(err.response?.data?.detail));
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F8FAFC] p-6">
      <div className="w-full max-w-md bg-white rounded-2xl border border-slate-200 shadow-sm p-8">
        <div className="mb-6"><Logo /></div>
        <h2 className="font-display text-2xl font-bold">Set a new password</h2>
        {!token ? (
          <p className="text-sm text-[#C42607] mt-4">Missing or invalid reset token. <Link to="/login" className="underline">Back to login</Link></p>
        ) : (
          <form onSubmit={submit} className="mt-6 space-y-4">
            <div>
              <Label className="text-xs font-medium text-slate-600">New Password</Label>
              <Input type="password" required minLength={8} value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1" data-testid="reset-password" />
            </div>
            <Button type="submit" className="w-full" disabled={loading} data-testid="reset-submit">{loading ? "Saving…" : "Update password"}</Button>
          </form>
        )}
      </div>
    </div>
  );
}
